import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { BackgroundMusic } from "./BackgroundMusic";
import { useApp } from "@/context/AppContext";
import { waLink } from "@/lib/whatsapp";
import { MessageCircle } from "lucide-react";

export default function StoreLayout() {
  const { settings } = useApp();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 pb-16 lg:pb-0"><Outlet /></main>
      <Footer />
      <a href={waLink(settings.whatsapp_number, "Hi LIVENEAT Organic, I need some help.")} target="_blank" rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-20 lg:bottom-6 right-4 lg:right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-105 transition-transform">
        <MessageCircle className="w-7 h-7 text-white" />
      </a>
      <BackgroundMusic />
      <MobileNav />
    </div>
  );
}
